import { Component, computed, inject } from '@angular/core';
import { DevErrorOverlayService, IDebugInfo } from './dev-error-overlay.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Component({
    selector: 'app-dev-error-overlay',
    standalone: true,
    templateUrl: './dev-error-overlay.component.html',
    styleUrls: ['./dev-error-overlay.component.scss'],
})
export class DevErrorOverlayComponent {
    protected readonly svc = injectRequired(DevErrorOverlayService);

    // Bouw de exception-keten op van buiten naar binnen
    protected readonly chain = computed<IDebugInfo[]>(() => {
        const result: IDebugInfo[] = [];
        let current = this.svc.error()?.debug;
        while (current) {
            result.push(current);
            current = current.innerException ?? undefined;
        }
        return result;
    });

    protected close(): void {
        this.svc.hide();
    }
}
